import React, { useContext, useState, useEffect } from 'react';
import kojaImage from './../container/image/koja.png';
import './placeInfo.css';
import { Link, useLocation, useHistory, useParams } from 'react-router-dom';
import Comments from '../user/comments';
import CreateComment from '../user/createComment';
import telegramImage from '../container/image/telegram.png';
import whatsappImage from '../container/image/whatsapp.png';
import instagramImage from '../container/image/instagram.png';
import phoneImage from '../container/image/phone.png';
import MainContext from '../context/mainContext';
import { getItemComments } from '../../service/commentService';
import config from './../../config.json'
import { requestCanceller } from '../../service/axiosCancelToken';
import { getPlaceInfoById } from '../../service/placeService';
import LoadingSpinner from '../shared/LoadingSpinner';

const PlaceInfo = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [place, setPlace] = useState(() => {
        if(state && state.place)
        return state.place;
        else
        return;
    });
    const [placeCategoryName, setPlaceCategoryName] = useState(() => {
        if(state && state.placeCategoryName)
        return state.placeCategoryName;
        else
        return;
    });
    const [isLoading, setIsLoading] = useState(false);
    const context = useContext(MainContext)

    const [lastCommentId, setLastCommentId] = useState(''); 
    const [comments, setComments] = useState(); 
    const [commentsLoading, setCommentsLoading] = useState(false);

    const getPlaceCommentsHandler = async (userId) => {
      try {
          setCommentsLoading(true);
          const params = {
              itemType: 'place',
              itemId: userId,
              lastCommentId: lastCommentId,
              commentsStatus: 'published'
          }
          const { status, data } = await getItemComments(params);
          if (status === 201) {
              if(data.comments.length){
                  const oldComments = comments ? [...comments] : [];
                  const newComments = oldComments.concat(data.comments)
                  setComments(newComments)
                  setLastCommentId(newComments[newComments.length - 1]._id);
              }
              setCommentsLoading(false);
          }
      } catch (err) {
         
          history.replace('/who');
      }
  }

      
  let { pid } = useParams();

  useEffect(() => {
      if(state && state.place)
      return;
      const checkID = new RegExp('^[0-9a-fA-F]{24}$');
      if(!checkID.test(pid))
      return history.replace('/who');
      const cancelRequest = requestCanceller();

      const fetchPlace = async () => {
          try {

              setIsLoading(true);
              let { status, data } = await getPlaceInfoById(pid,{cancelToken: cancelRequest.signal});
              if(status === 201){
                  setPlace(data.place);
                  setPlaceCategoryName(data.place.placeCategoryName);
              }
  
          } catch (err) {
              if(err.response && err.response.status === 404){
                history.replace('/who')
              }
          }
          setIsLoading(false);
      } 
      fetchPlace();

      return () => cancelRequest.cancel();
  },[state, history, pid]);

    return ( 
        <div className="bg-white py-3">
            {
                (!place || !placeCategoryName || isLoading) ?
                <div style={{ height: '60vh' }} className="d-flex">
                    <div className="text-center align-self-center mx-auto">
                        <LoadingSpinner />
                    </div>
                </div>
                :
                <div className="container">
                    <header className="">
                        <div className="">
                            <img src={kojaImage} alt="" className="main-image-top"/>
                            <small className="font-weight-bold ki-link"
                                onClick={() => history.replace('/where')}
                            >
                                کجا خوبه ؟ ( مکان ها ) / 
                            </small>
                            <small className="font-weight-bold ki-link"
                                onClick={() => history.goBack()}
                            >
                                {placeCategoryName} /
                            </small>
                            <small className="font-weight-bold">
                            {place.title}
                            </small>
                        </div>
                    </header>  
                    <section>
                        <div className="place-info-layer">
                            <div className="d-flex flex-wrap">
                                <div className="col-12 col-md-7 col-lg-6 text-center img-section">
                                    <img src={`${config.api_server}/${place.placeImage}`} alt="" className="img-fluid"/>
                                </div>
                                <div className="col-12 col-md-5 col-lg-6">
                                    <div className="my-3 text-center text-md-left">
                                        <span className="title-info">{place.title}</span>
                                    </div>
                                    <div className="">
                                        <span className="title-info">
                                            <i className="fa fa-address-card-o mr-2"></i>آدرس 
                                        </span>
                                        <span className="mx-1">:</span>
                                        <p className="text-secondary">
                                            {place.address}
                                        </p>
                                    </div>
                                    <div className="">
                                        <span className="title-info">
                                            <i className="fa fa-pencil mr-2"></i>توضیحات 
                                        </span>
                                        <span className="mx-1">:</span>
                                        <p className="text-secondary">
                                            {place.info}
                                        </p>
                                    </div>
                                    <div className="mb-2">
                                        <span className="font-weight-bold">
                                            <i className="fa fa-map-marker mr-1"></i>منطقه : 
                                        </span>
                                        <span className="ml-1">{place.areaName}</span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <div className="d-flex">
                                            <span className="title-info">
                                                <i className="fa fa-trophy mr-2"></i>نمره از 5
                                            </span>
                                            <span className="mx-1">:</span>
                                        </div>
                                        <div className="">
                                            <p className=" ratings">
                                            <Link to='' onClick={ event => event.preventDefault()}>
                                                <span className={place.score >= 5 ? "fa fa-star" : "fa fa-star-o"}></span>
                                            </Link>
                                            <Link to='' onClick={ event => event.preventDefault()}>
                                                <span className={place.score >= 4 ? "fa fa-star" : "fa fa-star-o"}></span>
                                            </Link>
                                            <Link to='' onClick={ event => event.preventDefault()}>
                                                <span className={place.score >= 3 ? "fa fa-star" : "fa fa-star-o"}></span>
                                            </Link>
                                            <Link to='' onClick={ event => event.preventDefault()}>
                                                <span className={place.score >= 2 ? "fa fa-star" : "fa fa-star-o"}></span>
                                            </Link>
                                            <Link to='' onClick={ event => event.preventDefault()}>
                                                <span className={place.score >= 1 ? "fa fa-star" : "fa fa-star-o"}></span>
                                            </Link>
                                            <Link to='' onClick={ event => event.preventDefault()} className="mark">{place.score}</Link>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="mt-lg-5">
                                        <div className="link-icons mt-auto">
                                            <span className="mr-auto tel">
                                                <span className="font-weight-bold">{place.telephone}</span>
                                                <img src={phoneImage} alt=""/>
                                            </span>
                                            <a className="social-icon" href={place.telegram}>
                                                <img src={telegramImage} alt=""/>
                                            </a>
                                            <a className="social-icon" href={place.instagram}>
                                                <img src={instagramImage} alt=""/>
                                            </a>
                                            <a className="social-icon" href={place.whatsapp}>
                                                <img src={whatsappImage} alt=""/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section> 
                    <section className="comments-section">
                        {
                            comments &&
                            <h5 className="">
                                <span>نظرات</span>
                            </h5>
                        }
                        {
                            (comments && comments.length)  &&
                            <Comments comments={comments}/> 
                        }
                        {
                            (comments && !comments.length) &&
                            <div className="d-flex justify-content-center" style={{ minHeight: '100px' }}>
                                <h6 className="align-self-center font-weight-bold">هیچ نظری تا کنون ثبت نشده است</h6>
                            </div>
                        }
                        <button className="btn btn-success mr-1 mr-md-0  mb-md-1 mt-3"
                            onClick={() => getPlaceCommentsHandler(place._id)}
                            disabled={commentsLoading}
                        >
                            <i 
                                className={commentsLoading ? 'spinner-border spinner-border-sm mr-2': ''} 
                                style={{position:'relative', bottom:'2px'}}
                            ></i>
                            {(comments && comments.length) ? 'مشاهده نظرات بیشتر' : 'مشاهده نظرات'} 
                        </button>
                        {
                            !context.loggedIn ? 
                            <div className="mt-5">
                                <button className="btn btn-success py-1 px-4" style={{marginRight:'15px'}}
                                    disabled={true}
                                >
                                    <i className="fa fa-pencil mr-2"></i>
                                    ثبت نظر
                                </button>
                                <p className="text-dark ml-1 mt-2" style={{fontSize:'1rem'}}>
                                    « برای ثبت نظر خود ، ابتدا باید 
                                    <span 
                                    className="text-primary" 
                                    onClick={context.showLogin}
                                    style={{cursor:'pointer'}}
                                        >  وارد  </span> 
                                        شوید »
                                </p>
                            </div>
                            :
                            <CreateComment 
                                userFullName={context.loggedIn.fullName}
                                itemType='place'
                                itemId={place._id}
                            />
                        }

                    </section> 
                </div>
            }
        </div>
     );
}
 
export default PlaceInfo;